import useTranslation from '@/hooks/useTranslation';
import ChevronRightIcon from '@bloomberg/web-icons-react/ChevronRight';
import type { FCl } from 'react-fc';
import styles from './Breadcrumb.module.css';

export interface IBreadcrumbItem {
    label: string;
    url: string;
}

interface IBreadcrumbProps {
    items: IBreadcrumbItem[];
}

/**
 * Breadcrumb component.
 */
export const Breadcrumb: FCl<IBreadcrumbProps> = ({ items, className }) => {
    const { t } = useTranslation();
    return (
        <ul className={`${styles.breadcrumb}${className ? ` ${className}` : ''}`}>
            <li>
                <a href="/">{t('SiteSection.home')}</a>
            </li>
            {items.map(({ url, label }) => (
                <li key={url}>
                    <ChevronRightIcon />
                    {url === '' ? label : <a href={url}>{label}</a>}
                </li>
            ))}
        </ul>
    );
};
